import type { JSX } from 'react';

import React from 'react';

import { clsx } from '../../jsx';

import type { PopupCommonStyle } from '@onetext/api';

type BaseCouponCodeProps = {
    style ?: PopupCommonStyle,
    text : string | undefined,
    handleCopy : () => Promise<void>,
};

export const BaseCouponCode = ({
    style,
    text,
    handleCopy
} : BaseCouponCodeProps) : JSX.Element => {

    return (
        <div
            className={
                clsx(
                    'w-full cursor-pointer text-center'
                )
            }
            style={ style }
            onClick={ () => void handleCopy() }
        >
            { text }
        </div>
    );
};
